import React from 'react';
import { Building2, Phone, Mail, Check, Plus } from 'lucide-react';
import type { MockVendor } from '@/types/purchaseFlow';

interface VendorListBlockProps {
  data: unknown;
  onAction: (message: string) => void;
  created?: boolean;
}

const VendorListBlock: React.FC<VendorListBlockProps> = ({ data, onAction, created }) => {
  const parsed = data as { vendors?: MockVendor[]; vendor_code?: string; name?: string };
  const vendors: MockVendor[] = parsed?.vendors || (parsed?.vendor_code ? [parsed as unknown as MockVendor] : []);

  if (vendors.length === 0) return null;

  return (
    <div className="space-y-2 mt-2">
      {vendors.map(vendor => (
        <div
          key={vendor.vendor_code}
          className={`rounded-lg border p-3 text-xs ${
            created
              ? 'border-emerald-200 dark:border-emerald-800 bg-emerald-50 dark:bg-emerald-900/20'
              : 'border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800'
          }`}
        >
          <div className="flex items-start justify-between gap-2">
            <div className="flex items-center gap-2">
              <Building2 className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" />
              <span className="font-semibold text-gray-800 dark:text-gray-200">{vendor.name}</span>
              <span className="text-gray-400 font-mono">{vendor.vendor_code}</span>
              {created && <Check className="w-3.5 h-3.5 text-emerald-500" />}
            </div>
          </div>
          <div className="mt-1.5 ml-5.5 space-y-0.5 text-gray-500 dark:text-gray-400">
            {vendor.tax_id && <div>Tax ID: {vendor.tax_id}</div>}
            {vendor.contact && <div className="flex items-center gap-1"><span>Contact: {vendor.contact}</span></div>}
            <div className="flex items-center gap-3">
              {vendor.phone && <span className="flex items-center gap-1"><Phone className="w-3 h-3" />{vendor.phone}</span>}
              {vendor.email && <span className="flex items-center gap-1"><Mail className="w-3 h-3" />{vendor.email}</span>}
            </div>
          </div>
          {!created && (
            <button
              onClick={() => onAction(`Use vendor ${vendor.vendor_code}`)}
              className="mt-2 ml-5.5 px-3 py-1 rounded-md text-xs font-medium bg-blue-50 text-blue-700 hover:bg-blue-100 dark:bg-blue-900/30 dark:text-blue-400 dark:hover:bg-blue-900/50 transition-colors"
            >
              Select Vendor
            </button>
          )}
        </div>
      ))}
      {!created && (
        <button
          onClick={() => onAction('Create new vendor')}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-gray-800 transition-colors"
        >
          <Plus className="w-3.5 h-3.5" /> Create New Vendor
        </button>
      )}
    </div>
  );
};

export default VendorListBlock;
